import { PubSkeletonWhiteBox } from "../../../../style/skeleton";
import {
  PremiumPubTournamentBlindWrapper,
  PremiumPubTournamentButtonWrapper,
  PremiumPubTournamentContent,
  PremiumPubTournamentContentWrapper,
  PremiumPubTournamentHeader,
  PremiumPubTournamentHeaderTitle,
  PremiumPubTournamentWrapper,
} from "./style";

const PremiumPubTournamentItemSkeleton = () => {
  return (
    <PremiumPubTournamentWrapper>
      <PremiumPubTournamentHeader>
        <PremiumPubTournamentHeaderTitle>
          <PubSkeletonWhiteBox height="18px" width="150px" />
          <PubSkeletonWhiteBox height="13px" width="200px" />
        </PremiumPubTournamentHeaderTitle>
        <PubSkeletonWhiteBox height="12px" width="57px" />
      </PremiumPubTournamentHeader>
      <PremiumPubTournamentContentWrapper>
        <PubSkeletonWhiteBox height="71px" width="73px" />
        <PremiumPubTournamentContent>
          <PubSkeletonWhiteBox height="23px" width="60px" />
          <PremiumPubTournamentBlindWrapper>
            <PubSkeletonWhiteBox height="40px" width="100%" />
            <PubSkeletonWhiteBox height="40px" width="100%" />
          </PremiumPubTournamentBlindWrapper>
        </PremiumPubTournamentContent>
      </PremiumPubTournamentContentWrapper>
      <PremiumPubTournamentButtonWrapper>
        <PubSkeletonWhiteBox height="35px" width="40px" />
        <PubSkeletonWhiteBox height="35px" width="100%" />
      </PremiumPubTournamentButtonWrapper>
    </PremiumPubTournamentWrapper>
  );
};

export default PremiumPubTournamentItemSkeleton;
